import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

interface TermsOfUseModalProps {
  open: boolean;
  handleCloseTerms: () => void;
  type: "terms" | "privacy"; // Define type explicitly
  title: string;
}

const TermsandConditions: React.FC<TermsOfUseModalProps> = ({
  open,
  handleCloseTerms,
  type,
}) => {

  const [termsContent, setTermsContent] = useState<string>("Loading...");
  const listRef = useRef<HTMLUListElement>(null);

  const handleWheel = (e: React.WheelEvent) => {
    const el = listRef.current;
    if (!el) return;

    // If user is scrolling inside the list, consume the event
    if (
      (el.scrollHeight > el.clientHeight) || // vertical scrollable
      (el.scrollWidth > el.clientWidth)      // horizontal scrollable
    ) {
      e.stopPropagation();
    }
  };

  useEffect(() => {
    if (open && type) {
      const fetchTerms = async () => {

        try {
          const response = await axios.get(
            `${API_BASE_URL}cms-content/page?web_site_id=${1}&language_id=${50}&tag_name=${type === "terms" ? "terms_conditions" : "privacy_policy"
            }`
          );
          const data = response?.data?.data;
          setTermsContent(data?.contentDesc || "No content available.");
        } catch (error) {
          console.error(`Error fetching ${type} content:`, error);
          setTermsContent("Failed to load content.");
        }
      };

      fetchTerms();
    }
  }, [open, type]); // Re-fetch when modal opens or type changes

  return (
    <Modal
      open={open}
      onClose={handleCloseTerms}
      aria-labelledby="terms-of-use-title"
    >
      <Box
        ref={listRef}
        onWheel={handleWheel}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          // Responsive width: uses different widths based on the screen size
          width: { xs: "70vw", sm: "80vw", md: "70vw", lg: "35vw" },
          height: "100%",
          maxHeight: "85vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          px: 5,
          py: 2,
          borderRadius: 2,
          zIndex: 1302, // Higher than modal backdrop
          pointerEvents: "auto", // Ensures clicks go through
        }}
      >
        {/* Close Button */}

        <IconButton
          onClick={() => {
            handleCloseTerms();
          }}
          className="deleteicon"
          aria-label="Close"
          sx={{
            position: "absolute",
            top: 10,
            right: 20,
            zIndex: 1500,
            border: "2px solid #e5e5e5",
            borderRadius: "50%",
            width: "32px", // Smaller button
            height: "32px",
            "&:hover": {
              border: "2px solid #e5e5e5",
              backgroundColor: "#fdfdfdca",
              color: "#fff",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 18, color: "#353535" }} /> {/* Smaller icon */}
        </IconButton>

        {/* Modal Title */}
        {/* Render Terms HTML Content */}
        <div dangerouslySetInnerHTML={{ __html: termsContent }} />
      </Box>
    </Modal>
  );
};

export default TermsandConditions;
